export default __webpack_public_path__ + "static/media/icons8-mail.650ff70b.svg";